import { MutatingDots } from "react-loader-spinner";
import './appLoader.css';

const AppLoader = () => {
  return (
    <div className="appLoaderRoot">
     
<MutatingDots 
  height={100}
  width={100}
    color="#3b82f6" 
    secondaryColor="#60a5fa" 
  radius={12.5}
  ariaLabel="mutating-dots-loading"
  visible={true}
/>
    </div>
  );
};

export default AppLoader;
